import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Divider
} from '@mui/material';
import { LoginButton } from './LoginButton';
import { EmailAuthForm } from './EmailAuthForm';

interface LoginDialogProps {
  open: boolean;
  onClose: () => void;
}

export const LoginDialog: React.FC<LoginDialogProps> = ({ open, onClose }) => {
  const handleAuthSuccess = () => {
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h5" align="center" fontWeight="bold">
          Sign in to Email Previewer
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center',
          py: 3,
          gap: 2
        }}>
          <Typography variant="body1" color="text.secondary" align="center" gutterBottom>
            Sign in to save your templates and access pro features
          </Typography>
          
          <EmailAuthForm onSuccess={handleAuthSuccess} />
          
          <Divider sx={{ width: '100%', my: 2 }}>or</Divider>
          
          <LoginButton onSuccess={handleAuthSuccess} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}; 